"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Translation = exports.withTranslation = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRedux = require("react-redux");

var _react2 = require("../../util/react.js");

var _redux = require("../../util/redux.js");

var _object = require("../../util/object.js");

var selectors = _interopRequireWildcard(require("../store.js"));

var _actions = require("../../routing/actions.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var withTranslation = function withTranslation(ComponentToWrap) {
  var stateToProps = (0, _redux.createStateToProps)({
    translate: selectors.newTranslate
  });
  var wrappedComponent = (0, _reactRedux.connect)(stateToProps)(ComponentToWrap);
  wrappedComponent.propTypes = (0, _object.removeKeys)(ComponentToWrap.propTypes || {}, ["translate"]);
  return wrappedComponent;
};

exports.withTranslation = withTranslation;

var TranslationComponent = function TranslationComponent(props) {
  var code = props.code,
      translate = props.translate,
      data = props.data,
      navigate = props.navigate,
      to = props.to,
      onLinkedTextClick = props.onLinkedTextClick,
      linkUrlCode = props.linkUrlCode;
  var className = (0, _classnames["default"])("translation", props.className);
  var linkUrl = linkUrlCode && translate(linkUrlCode);
  var handleLinkedTextClick = to || onLinkedTextClick ? function (event) {
    if (onLinkedTextClick) {
      onLinkedTextClick(event);
    }

    if (to) {
      navigate(to);
    }
  } : undefined;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: className,
    "data-code": code
  }, (0, _react2.substitute)(translate(code), data, {
    onLinkedTextClick: handleLinkedTextClick,
    href: linkUrl
  }));
};

TranslationComponent.propTypes = {
  className: _propTypes["default"].string,
  translate: _propTypes["default"].func.isRequired,
  code: _propTypes["default"].string.isRequired,
  data: _propTypes["default"].object,
  onLinkedTextClick: _propTypes["default"].func,
  navigate: _propTypes["default"].func,
  to: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
    pathname: _propTypes["default"].string
  })]),
  linkUrlCode: _propTypes["default"].string
};

var dispatchToTranslationProps = function dispatchToTranslationProps(dispatch) {
  return {
    navigate: function navigate(location) {
      return dispatch((0, _actions.navigate)(location));
    }
  };
};

var Translation = withTranslation((0, _reactRedux.connect)(undefined, dispatchToTranslationProps)(TranslationComponent));
exports.Translation = Translation;